import tinyColor from 'tinycolor2';

import { defaultBrandingColors } from '../constants/branding.constants';

export const getBrandingColor = (color: string, defaultColor: defaultBrandingColors): string => {
  const colorObject = tinyColor(color);
  return colorObject.isValid() ? colorObject.toHexString() : defaultColor;
};
